<template>
  <div
    class="data-grid-head-cell"
    :class="[
      align === 'center' && 'text-center',
      align === 'right' && 'text-right',
      sortable && 'cursor-pointer hover:bg-zinc-100 dark:hover:bg-zinc-600',
      className,
    ]"
    data-testid="head-cell"
    @click="handleClick"
  >
    <div class="head-cell-content">
      <slot>{{ label }}</slot>
      <span v-if="sortable && sortDirection" class="sort-indicator">
        <Icon
          :name="sortDirection === 'asc' ? 'general.chevronUp' : 'general.chevronDown'"
          size="xs"
          class="ml-1"
        />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@/storybook';

interface Props {
  label?: string;
  align?: 'left' | 'center' | 'right';
  sortable?: boolean;
  sortDirection?: 'asc' | 'desc' | null;
  sortKey?: string;
  className?: string;
}

const props = withDefaults(defineProps<Props>(), {
  align: 'left',
  sortable: false,
  sortDirection: null,
});

interface Emits {
  (e: 'sort', sortKey: string): void;
}

const emit = defineEmits<Emits>();

const handleClick = () => {
  if (props.sortable && props.sortKey) {
    emit('sort', props.sortKey);
  }
};
</script>

<style scoped>
.data-grid-head-cell {
  @apply px-6 py-3 text-xs font-medium text-zinc-500 dark:text-zinc-300 uppercase tracking-wider;
  @apply transition-colors;
  @apply bg-zinc-50 dark:bg-zinc-700;
  @apply border-b border-zinc-200 dark:border-zinc-600;
  display: table-cell;
  vertical-align: middle;
}

.head-cell-content {
  @apply flex items-center;
}

.sort-indicator {
  @apply inline-flex items-center flex-shrink-0;
}
</style>